var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { last } from 'lodash';
import Footer from 'components/footer/Footer';
import Tabs from 'components/tabs/Tabs';
import modulesMap from 'core/modulesMap';
import { bindEmitterMethod } from 'helpers/bind';
import MainPage from 'navigation/pages/MainPage';
import TabsPage from 'navigation/pages/TabsPage';
var Faq = /** @class */ (function (_super) {
    __extends(Faq, _super);
    function Faq() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        Object.defineProperty(_this, "setTabsHeaderHeight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                return TabsPage.prototype.setTabsHeaderHeight.call(_this);
            }
        });
        return _this;
    }
    Object.defineProperty(Faq.prototype, "initialized", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            _super.prototype.initialized.call(this);
            var detectQuestion = new URLSearchParams(window.location.search).get('qid');
            if (detectQuestion)
                this.goToQuestion(detectQuestion);
        }
    });
    Object.defineProperty(Faq.prototype, "getModulesMap", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __assign(__assign({}, modulesMap), { tabs: ['.tabs', Tabs], adaptableWrapper: modulesMap.adaptableWrapper, footer: ['footer', Footer] });
        }
    });
    Object.defineProperty(Faq.prototype, "resize", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return TabsPage.prototype.resize.call(this);
        }
    });
    Object.defineProperty(Faq.prototype, "show", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            return (_a = TabsPage.prototype.show).call.apply(_a, __spreadArray([this], __read(arguments), false));
        }
    });
    Object.defineProperty(Faq.prototype, "bindEvents", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (add) {
            var _this = this;
            var emitterMethod = bindEmitterMethod(add);
            this.modules.tabs[emitterMethod]('tabChange', function (tab) {
                _this.refs.pageTabsCategory.forEach(function (category) {
                    var _a, _b;
                    (_a = category.classList) === null || _a === void 0 ? void 0 : _a.remove('active');
                    if (category.dataset.category === tab) {
                        (_b = category.classList) === null || _b === void 0 ? void 0 : _b.add('active');
                        _this.modules.drawer.forEach(function (drawer) {
                            drawer.resize();
                        });
                    }
                });
            });
        }
    });
    Object.defineProperty(Faq.prototype, "shouldRouteInternally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (el, pathName) {
            return true;
        }
    });
    Object.defineProperty(Faq.prototype, "internalRouting", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (pathName, xhr, requestOptions) {
            return __awaiter(this, void 0, void 0, function () {
                var search, detectQuestion;
                return __generator(this, function (_a) {
                    search = last(xhr.responseURL.split('?'));
                    detectQuestion = new URLSearchParams(search).get('qid');
                    if (detectQuestion)
                        this.goToQuestion(detectQuestion);
                    return [2 /*return*/];
                });
            });
        }
    });
    Object.defineProperty(Faq.prototype, "goToQuestion", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (qid) {
            var _a;
            var accordions = this.refs.faqAccordion;
            var accordion = accordions.find(function (accordion) { return accordion.dataset.id === qid; });
            var accordionParent = accordion === null || accordion === void 0 ? void 0 : accordion.parentElement;
            this.modules.tabs.activeTab = this.modules.tabs.refs.tabsLinks.find(function (link) { return link.dataset.tab === (accordionParent === null || accordionParent === void 0 ? void 0 : accordionParent.dataset.category); });
            this.modules.tabs.refs.tabsLinks.forEach(function (link) { return link.classList.remove('active'); });
            this.modules.tabs.activeTab.classList.add('active');
            this.modules.tabs.emit('tabChange', this.modules.tabs.activeTab.dataset.tab);
            this.modules.tabs.updateTrack(this.modules.tabs.activeTab);
            (_a = accordion.firstElementChild) === null || _a === void 0 ? void 0 : _a.setAttribute('checked', 'true');
        }
    });
    Object.defineProperty(Faq, "pageName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'Faq'
    });
    return Faq;
}(MainPage));
export default Faq;
